import { DateTime } from 'luxon'
import { SchedulingMonth } from './types'

export const TODAY = DateTime.now()

export const schedulingMonths = (): SchedulingMonth[] => {
  return [
    {
      label: `${TODAY.toFormat('LLLL')} de ${TODAY.toFormat('y')}`,
      value: TODAY.toFormat('D'),
    },
    {
      label: `${TODAY.plus({ months: 1 }).toFormat('LLLL')} de ${TODAY.plus({
        months: 1,
      }).toFormat('y')}`,
      value: TODAY.plus({ months: 1 }).toFormat('D'),
    },
    {
      label: `${TODAY.plus({ months: 2 }).toFormat('LLLL')} de ${TODAY.plus({
        months: 2,
      }).toFormat('y')}`,
      value: TODAY.plus({ months: 2 }).toFormat('D'),
    },
    {
      label: `${TODAY.plus({ months: 3 }).toFormat('LLLL')} de ${TODAY.plus({
        months: 3,
      }).toFormat('y')}`,
      value: TODAY.plus({ months: 3 }).toFormat('D'),
    },
  ]
}
export const SEX_OPTIONS = [
  {
    id: '1',
    key: '1',
    label: 'Masculino',
    value: '1',
  },
  {
    id: '2',
    key: '2',
    label: 'Feminino',
    value: '2',
  },
  {
    id: '3',
    key: '3',
    label: 'Outros',
    value: '3',
  },
]

export const IMMEDIATE_ATTENDANCE = 'immediate'
export const SCHEDULED_ATTENDANCE = 'scheduled'
export const SCHEDULED_ATTENDANCE_W_PREFERENCE = 'scheduled_w_preference'
